export enum WindowSizes {
  MaxPadWidth = 1100,
  MaxMobileWidth = 720,
  MinMobileWidth = 320
}
